import React from "react";
import * as Icons from "@wix/wix-ui-icons-common";
import { Table, Image, Box, Button } from "@wix/design-system";
import searchLogo from "../../../dashboard/pages/search.svg";

interface EmptyTableProps {
  hasKeywords: boolean;
  onChange: () => void;
  title?: string;
  description?: string;
  actions?: any;
}

const EmptyTable: React.FC<EmptyTableProps> = ({
  hasKeywords,
  onChange,
  title = "",
  description = "",
  actions = [],
}) => {
  function handleClearSearch() {
    onChange();
  }

  return (
    <>
      <Table.EmptyState
        title={hasKeywords ? "No results found" : title}
        subtitle={hasKeywords ? "No items matched your search. Try searching for something else." : description}
        image={<Image width="120px" height="120px" transparent={true} src={searchLogo} />}
      >
        <Box gap={"20px"}>
          {hasKeywords && (
            <Button size="small" priority="secondary" onClick={handleClearSearch} prefixIcon={<Icons.Dismiss />}>
              Clear Search
            </Button>
          )}

          {actions.map((action: any) => action)}
        </Box>
      </Table.EmptyState>
    </>
  );
};

export default EmptyTable;
